export default class PayrollPdf {
  parse(data) {
    this.body = data.body;
  }
}
